module.exports = __webpack_public_path__ + "img/convenzioni.f2688765.png";